export const store = {
  state: {
    collapseNavigation: true
  },
  toggleCollapsedState () {
    this.state.collapseNavigation = !this.state.collapseNavigation
  }
}
